import { Navigate } from 'react-router-dom';

export default function IncomePage() {
  return <Navigate to="/transactions/income" replace />;
}
